<template>
  <div class="background">
    <svg class="title-text" viewBox="0 0 271.4 24">
      <text class="title" x="5" y="22" font-size="22">Connections</text>
    </svg>
    <div class="status">
      <svg
        id="con-stat"
        class="status-icon"
        viewBox="0 0 5.95 1"
        preserveAspectRatio="xMidYMid meet"
      >
        <text x="2.975" y="0.7" font-size="0.55" text-anchor="middle">
          Connected
        </text>
      </svg>
      <svg
        id="sig-stat"
        :class="signalIconClass"
        viewBox="0 0 5.90 1"
        preserveAspectRatio="xMidYMid meet"
      >
        <text x="2.95" y="0.7" font-size="0.55" text-anchor="middle">
          {{ signalQualityMsg }}
        </text>
      </svg>
    </div>
    <div class="icon"></div>
  </div>
</template>

<script>
export default {
  name: 'ConnectionStats',
  props: {
    signalQualityGood: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    signalQualityMsg() {
      if (this.signalQualityGood) {
        return 'Signal Quality Good'
      } else {
        return 'Low Signal Quality'
      }
    },
    signalIconClass() {
      return {
        'status-icon': true,
        'signal-bad': !this.signalQualityGood
      }
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.background {
  display: grid;
  box-sizing: border-box;
  padding-left: 0.5%;
  grid-template-rows: 25% 75%;
  grid-template-columns: 25% 75%;
}
.title-text {
  grid-row: 1;
  grid-column-start: 1;
  grid-column-end: 3;
  width: 100%;
  fill: #00413b;
}
.status {
  grid-row: 2;
  grid-column: 2;
  display: grid;
  grid-template-rows: 45% 45%;
  row-gap: 10%;
  box-sizing: border-box;
  padding: 3% 3% 3% 2%;
  fill: white;
}
.status-icon {
  background-color: #5ba269;
  color: white;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}
#con-stat {
  grid-row: 1;
}
#sig-stat {
  grid-row: 2;
}
.icon {
  grid-row: 2;
  grid-column: 1;
  background-image: url('../assets/monitor.svg');
  background-size: 85%;
  background-repeat: no-repeat;
  background-position: center;
  overflow: visible;
}
</style>
